import React from 'react';
import { StyleRoot } from 'radium';

export function AnimationLayout({ children, animation }) {
  return (
    <StyleRoot>
      <div style={animation}>{children}</div>
    </StyleRoot>
  );
}
